import Link from 'next/link';
import React, { useState, useEffect } from 'react';

export default function CategoryNavItem({ item, firstItem, isMenuHovered }) {
  const [isHovered, setIsHovered] = useState(firstItem);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    if (firstItem && !isMenuHovered) {
      setIsHovered(firstItem);
    }
  }, [firstItem, isMenuHovered]);

  const renderMenuItem = (menuItem, isTopLevel) => {
    const itemClass = isTopLevel ? 'font-bold border-r-2 mt-2' : 'text-xs';
    return (
      <React.Fragment key={menuItem.id}>
        <Link
          href={`${
            menuItem.type == 'product_category'
              ? '/cat'
              : menuItem.type == 'brand'
              ? '/brand'
              : menuItem.type == 'page'
              ? '/page'
              : ''
          }${menuItem.url}`}
          target="_blank"
          className={` w-1/4  border-color-primary pr-2 ${itemClass}`}
        >
          {menuItem.title}
        </Link>
        {menuItem.children.length > 0 &&
          menuItem.children.map((childItem, index) =>
            renderMenuItem(childItem, false, index)
          )}
      </React.Fragment>
    );
  };

  return (
    <div
      className="menuItem w-56 py-0.5 px-2 "
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        href={`${
          item.type == 'product_category'
            ? '/cat'
            : item.type == 'brand'
            ? '/brand'
            : item.type == 'page'
            ? '/page'
            : ''
        }${item.url}`}
        target="_blank"
        className={`p-2 px-2 block flex items-center rounded-md ${
          isHovered ? 'bg-[#F1F9FF] text-color-primary' : 'text-dark-gray'
        }`}
      >
        {item.icon && (
          <span
            className="icon pl-2 "
            dangerouslySetInnerHTML={{ __html: item.icon }}
          />
        )}
        {item.title}
      </Link>
      {item.children.length > 0 && (
        <div
          className={`submenu  border-r border-light-gray-300 p-4 absolute top-0 left-0 right-56 h-full flex flex-col gap-2.5 flex-wrap h-[320px]  ${
            isHovered ? '' : 'hidden'
          }`}
        >
          {item.children.map(
            (childItem) => renderMenuItem(childItem, true) // Pass true for top-level items
          )}
        </div>
      )}
    </div>
  );
}
